import React, { useState, useRef } from 'react';
import SmartSearchField from './SmartSearchField';
import EmailModal from './EmailModal';

const SearchSimple = () => {
  const [selectedBusiness, setSelectedBusiness] = useState<any>(null);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const createSiteButtonRef = useRef<HTMLButtonElement>(null);

  const handleBusinessSelected = (business: any) => {
    console.log('Business selected:', business);
    setSelectedBusiness(business);
    
    // Sequência corrigida: aguardar o SmartSearchField completar toda a transição
    setTimeout(() => {
      if (createSiteButtonRef.current) {
        // Dar foco no botão para melhor UX
        createSiteButtonRef.current.focus();
        
        // Scroll suave para mostrar o botão no mobile
        const isMobileDevice = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768;
        
        if (isMobileDevice) {
          createSiteButtonRef.current.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center',
            inline: 'nearest'
          });
        }
        
        console.log('🎯 Foco movido para botão "Criar Site" após seleção');
      }
    }, 100); // Reduzido para 100ms pois agora o SmartSearchField gerencia a sequência corretamente
  };

  const handleCreateWebsite = () => {
    if (!selectedBusiness) {
      alert('Por favor, selecione um profissional primeiro.');
      return;
    }
    
    setShowEmailModal(true);
  };

  const handleEmailSubmit = async (email: string, password: string) => {
    console.log('Form submitted:', { email, password, business: selectedBusiness });
    
    try {
      // Enviar dados para o webhook via API backend
      const response = await fetch('/api/webhook/create-website', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email,
          password,
          businessData: selectedBusiness
        })
      });

      const result = await response.json();
      
      if (result.success) {
        setShowEmailModal(false);
        alert(`✅ Site criado com sucesso para ${selectedBusiness.name}!\n\nEmail: ${email}\nStatus: ${result.message}\n\nVerifique seu email para acessar!`);
      } else {
        throw new Error(result.error || 'Erro ao criar site');
      }
    } catch (error) {
      console.error('Erro ao criar site:', error);
      const errorMessage = error instanceof Error ? error.message : 'Erro desconhecido';
      alert(`❌ Erro ao criar site: ${errorMessage}\n\nTente novamente em alguns instantes.`);
    }
  };

  const handleModalClose = () => {
    setShowEmailModal(false);
  };

  return (
    <section className="section search-section" style={{ 
      background: 'white', 
      padding: '4rem 0',
      position: 'relative' 
    }}>
      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
          {/* Top tagline */}
          <div style={{
            fontSize: '1rem',
            color: '#6b7280',
            marginBottom: '2rem',
            fontWeight: '500'
          }}>
            Especialistas em sites para profissionais da saúde
          </div>
          
          <h2 style={{ 
            fontSize: 'clamp(2rem, 5vw, 3rem)', 
            fontWeight: 'bold', 
            color: '#111827',
            marginBottom: '1.5rem',
            lineHeight: '1.2'
          }}>
            Digite nome e sobrenome{' '}
            <span style={{ color: '#fbbf24' }}>como aparece no Google</span>
          </h2>
        </div>

        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          {/* Blue info box */}
          <div style={{
            background: '#dbeafe',
            border: '1px solid #93c5fd',
            borderRadius: '0.75rem',
            padding: '1rem 1.5rem',
            marginBottom: '2rem',
            textAlign: 'center',
            color: '#1e40af',
            fontSize: '1rem',
            fontWeight: '500'
          }}>
            ✨ Beno cria seu site em 5 minutos
          </div>

          {/* Smart Search Field */}
          <SmartSearchField onBusinessSelected={handleBusinessSelected} />

          {/* CTA Button */}
          <div style={{ textAlign: 'center', marginTop: '2rem' }}>
            <button
              ref={createSiteButtonRef}
              onClick={handleCreateWebsite}
              disabled={!selectedBusiness}
              style={{
                background: !selectedBusiness ? '#9ca3af' : '#6b7280',
                color: 'white',
                fontWeight: 'bold',
                padding: '1rem 2.5rem',
                borderRadius: '0.75rem',
                border: 'none',
                cursor: !selectedBusiness ? 'not-allowed' : 'pointer',
                fontSize: '1.125rem',
                transition: 'all 0.3s ease',
                boxShadow: !selectedBusiness ? 'none' : '0 4px 15px rgba(107, 114, 128, 0.3)'
              }}
              onMouseEnter={(e) => {
                if (selectedBusiness) {
                  (e.target as HTMLButtonElement).style.transform = 'translateY(-2px)';
                  (e.target as HTMLButtonElement).style.boxShadow = '0 6px 20px rgba(107, 114, 128, 0.4)';
                }
              }}
              onMouseLeave={(e) => {
                if (selectedBusiness) {
                  (e.target as HTMLButtonElement).style.transform = 'translateY(0)';
                  (e.target as HTMLButtonElement).style.boxShadow = '0 4px 15px rgba(107, 114, 128, 0.3)';
                }
              }}
            >
              ✨ Criar Site
            </button>
          </div>

          {/* Bottom features */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '2rem',
            marginTop: '2rem',
            fontSize: '0.875rem',
            color: '#6b7280',
            flexWrap: 'wrap'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <div style={{ 
                width: '0.5rem', 
                height: '0.5rem', 
                background: '#10b981', 
                borderRadius: '50%'
              }}></div>
              <span>⚡ Criado em 5 minutos</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <div style={{ 
                width: '0.5rem', 
                height: '0.5rem', 
                background: '#2563eb', 
                borderRadius: '50%'
              }}></div>
              <span>🔍 Google e ChatGPT</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <div style={{ 
                width: '0.5rem', 
                height: '0.5rem', 
                background: '#10b981', 
                borderRadius: '50%'
              }}></div>
              <span>🆓 7 dias grátis</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <div style={{ 
                width: '0.5rem', 
                height: '0.5rem', 
                background: '#7c3aed', 
                borderRadius: '50%'
              }}></div>
              <span>✅ Sem compromisso</span>
            </div>
          </div>
        </div>
      </div>

      {/* Email Modal */}
      <EmailModal 
        isOpen={showEmailModal}
        onClose={handleModalClose}
        onSubmit={handleEmailSubmit}
        businessName={selectedBusiness?.name || ''}
      />
    </section>
  );
};

export default SearchSimple;